import React, { useEffect, useRef } from "react";
import { pdf } from "@react-pdf/renderer";
import { GenerateFinancialFile } from "#components/generate-financial-file/generate-financial-file";
import { RequestClosingOfEventOperationResponseJSON } from "#components/generate-financial-file/types";

type Props = {
	data?: RequestClosingOfEventOperationResponseJSON;
	onDownloadComplete?: () => void;
};

export default function AutoDownloadPDF({ data, onDownloadComplete }: Props) {
	const hasDownloadedRef = useRef(false);

	useEffect(() => {
		if (!data || hasDownloadedRef.current) return;

		const generateAndDownload = async () => {
			try {
				const blob = await pdf(<GenerateFinancialFile data={data} />).toBlob();

				const url = URL.createObjectURL(blob);
				const a = document.createElement("a");
				a.href = url;
				a.download = `${data.placeName}-${data.contractNumber}-${new Date()
					.toLocaleDateString("pt-BR", {
						day: "2-digit",
						month: "2-digit",
						year: "numeric",
					})
					.replace(/\//g, "")}.pdf`;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);

				URL.revokeObjectURL(url);

				hasDownloadedRef.current = true;
				onDownloadComplete?.();
			} catch (error) {
				console.error("Erro ao gerar PDF:", error);
			}
		};

		generateAndDownload();
	}, [data, onDownloadComplete]);

	useEffect(() => {
		hasDownloadedRef.current = false;
	}, [data]);

	return null;
}
